import { render, staticRenderFns } from "./FlowsView.vue?vue&type=template&id=32e99456"
import script from "./FlowsView.vue?vue&type=script&lang=js"
export * from "./FlowsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports